import { render, staticRenderFns } from "./ModalProductOutput.vue?vue&type=template&id=35b13a8d&"
import script from "./ModalProductOutput.vue?vue&type=script&lang=js&"
export * from "./ModalProductOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports